// Arrays use newest-first OHLCV ordering, matching the chart script engine.
export function standardIndicator(kind, h, l, c, v, length=20, annualization=252) {
    length=Math.max(2,Math.floor(length));
    if(!Number.isFinite(length) || c.length<length || c.slice(0,length).some(x=>!Number.isFinite(x))) return NaN;
    const mean=a=>a.reduce((s,x)=>s+x,0)/a.length;
    const closes=c.slice(0,length);
    if(kind==='DPO') return c[Math.floor(length/2)+1]-mean(closes);
    if(kind==='Vortex') {
        if(c.length<length+1 || h.length<length+1 || l.length<length+1) return [NaN,NaN];
        let plus=0,minus=0,tr=0;
        for(let i=0;i<length;i++) {
            plus+=Math.abs(h[i]-l[i+1]);minus+=Math.abs(l[i]-h[i+1]);
            tr+=Math.max(h[i]-l[i],Math.abs(h[i]-c[i+1]),Math.abs(l[i]-c[i+1]));
        }
        return tr ? [plus/tr,minus/tr] : [0,0];
    }
    if(kind==='Aroon') {
        if(h.length<length+1||l.length<length+1)return [NaN,NaN,NaN];
        let hi=0,lo=0;
        for(let i=1;i<=length;i++) {if(h[i]>h[hi])hi=i;if(l[i]<l[lo])lo=i;}
        const up=100*(length-hi)/length,down=100*(length-lo)/length;
        return [up,down,up-down];
    }
    if(kind==='BollingerPercentB') {
        const average=mean(closes),sd=Math.sqrt(mean(closes.map(x=>(x-average)**2)));
        return sd ? (c[0]-(average-2*sd))/(4*sd) : .5;
    }
    if(kind==='UlcerIndex') {
        // Each drawdown uses only bars at or before that historical bar.
        if(c.length<length*2-1) return NaN;
        return Math.sqrt(mean(closes.map((x,i)=>{
            const peak=Math.max.apply(null,c.slice(i,i+length));
            return peak ? ((x-peak)/peak*100)**2 : 0;
        })));
    }
    if(kind==='HistoricalVolatility') {
        if(c.length<length+1 || c.slice(0,length+1).some(x=>x<=0)) return NaN;
        const returns=closes.map((x,i)=>Math.log(x/c[i+1])),average=mean(returns);
        return Math.sqrt(returns.reduce((sum,x)=>sum+(x-average)**2,0)/(length-1))*Math.sqrt(annualization)*100;
    }
    if(kind==='ChoppinessIndex') {
        if(c.length<length+1 || h.length<length || l.length<length) return NaN;
        let total=0;
        for(let i=0;i<length;i++) total+=Math.max(h[i]-l[i],Math.abs(h[i]-c[i+1]),Math.abs(l[i]-c[i+1]));
        const range=Math.max.apply(null,h.slice(0,length))-Math.min.apply(null,l.slice(0,length));
        return range>0 && total>0 ? 100*Math.log10(total/range)/Math.log10(length) : 0;
    }
    return NaN;
}
